// src/GlobalStyle.js
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    transition: all 0.3s ease;
  }

  body {
    font-family: 'Poppins', sans-serif;
    background-color: #f4f5f7;
    color: #333;
    line-height: 1.6;
  }

  h1, h2, h3, h4, h5, h6, p {
    margin-bottom: 10px;
    color: #444;
  }

  a {
    text-decoration: none;
  }

  /* Dark mode settings */
  body[data-theme='dark'] {
    background-color: #000;
    color: #ecf0f1;
  }

  body[data-theme='dark'] h1, body[data-theme='dark'] h2, body[data-theme='dark'] h3, body {
    color: #ecf0f1;
  }

  /* Smooth scroll */
  html {
    scroll-behavior: smooth;
  }

  /* Responsive media queries */
  @media screen and (max-width: 768px) {
    body {
      font-size: 14px;
    }
  }

  .centered {
    display: block;
    text-align: center;
  }
  .ReactModal__Overlay {
    margin-left: 200px;
    background: linear-gradient(0deg, #1a181c, #000);
  }
  @media screen and (max-width: 768px) {
    .ReactModal__Overlay {
      margin-left: 0;
    }
  }
`;

export default GlobalStyle;
